<template>
	<div class="sp-template">
		<div class="h-title">汇率管理</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
          <el-form-item label="币种">
            <el-input v-model="conditions.currency" auto-complete="off" placeholder="币种"></el-input>
          </el-form-item>
          <el-button  v-if="in_configs(71303)" size="small" type="primary" @click="initQuery">搜索</el-button>
				</el-form>
				<div>
					<el-button v-if="in_configs(71301)" size="small" class="btn-cyan" @click="createExchangeRate">添加</el-button>
				</div>
			</div>
			<el-table ref="multipleTable" :data="exchangeRateData" stripe tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="currency" label="币种"></el-table-column>
				<el-table-column prop="exchangeRate" label="汇率"></el-table-column>
				<el-table-column label="最新更新时间">
          <template slot-scope="scope">
            {{timestampToTime(scope.row.createDate)}}
          </template>
        </el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<i v-if="in_configs(71302)" class="el-icon-edit-outline" @click="handleEdit(scope.$index, scope.row)" title="编辑"></i>
						<i v-if="in_configs(71304)" class="el-icon-search" @click="popEditLog(scope.row.id)" title="查看编辑记录"></i>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background 
				@size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :current-page="currentPage" 
        :page-sizes="[10, 20, 50, 100]" 
        :page-size="pageSize" 
        layout="total, sizes, prev, pager, next, jumper" 
        :total = "parseInt(total)">
			</el-pagination>

			<!-- 弹窗 -->
			<el-dialog title="添加/修改" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="resetForm('exchangeRateForm')" width="500px" class="fullwidth-form__dialog">
				<el-form :model="exchangeRateForm" status-icon :rules="rule" ref="exchangeRateForm" size="small" :label-width="formLabelWidth">
					<el-form-item label="币种" prop="currency">
            <el-select name="currency" v-model="exchangeRateForm.currency">
              <el-option v-for="currency in currencies" :label="currency.name" :value="currency.value" :key="currency.name"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item label="汇率" prop="exchangeRate">
						<el-input v-model="exchangeRateForm.exchangeRate" auto-complete="off" placeholder="汇率"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="resetForm('exchangeRateForm')">取 消</el-button>
					<el-button size="small" type="primary" @click="save('exchangeRateForm')">确 定</el-button>
				</div>
			</el-dialog>

      <!-- 查看汇率编辑历史弹层 -->
      <el-dialog title="汇率编辑历史" :visible.sync="exchangeRateEditLogsVisible" width="800px">
        <el-table style="width: 100%" :data="exchangeRateEditLogs">
          <el-table-column label="时间" prop="operationAt"></el-table-column>
          <el-table-column label="描述">
            <template slot-scope="scope">
              <div v-for="(d, i) in scope.row.operationObject.values" :key="i">
                <span>{{d.name}}： 原始值：{{d.originValue}} 修改值：{{d.newValue}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作人" width="120px">
            <template slot-scope="scope">
              {{scope.row.operator}}
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
  data() {
    // 校验币种是否存在
    var checkCurrency = (rule, value, callback) => {
      this.$request1({
        method: 'GET',
        url: '/exchange/check',
        params: { 
          id: this.exchangeRateForm.id,
          currency: this.exchangeRateForm.currency
        }
      })
        .then(response => {
          if (!response.data.success) {
            callback(new Error(response.data.message));
          } else {
            callback();
          }
        })
        .catch(error => {});
    };
    return {
      exchangeRateEditLogsVisible: false,
      exchangeRateEditLogs: [],
      conditions: {
        currency: ""
      },
      exchangeRateData: [],
      exchangeRateForm: {
        id: "",
        currency: "",
        exchangeRate: ""
      },
      currentPage: 1, // 当前是第几页
      pageSize: 50, // 每页显示条目个数
      total: 0, // 总条目数
      dialogFormVisible: false,
      formLabelWidth: "80px",
      rule: {
        currency: [
          { required: true, message: "请选择币种", trigger: "change" },
          { validator: checkCurrency, trigger: "change" }
        ],
        exchangeRate: [
          { required: true, message: "请输入汇率", trigger: "blur" },
          {
            pattern: /^([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])$/,
            message: "汇率必须是大于0的数字",
            trigger: "blur"
          },
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,3})?$/,
            message: "最多保留三位小数",
            trigger: "blur"
          }
        ]
      },
      currencies: []
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.query();
    }, 600);
  },
  computed: {
    //权限
    configs() {
      let conf = JSON.parse(sessionStorage.configs),
        arr = [];
      conf.forEach((d, i) => {
        arr.push(d.name);
      });
      return arr;
    }
  },
  methods: {
    // 时间戳转换成时间
    timestampToTime (data) {
      let date = new Date(data);
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s
    },
    // 搜索
    initQuery(){
      this.currentPage = 1;
      this.query();
    },
    // 初始化查询方法
    query() {
      let _this = this;
      _this.$request1({
        method: 'GET',
        url: '/exchange/query',
        params: {
          currency: _this.conditions.currency,
          currentPage: _this.currentPage,
          pageSize: _this.pageSize
        }
      })
        .then(response => {
          if (response.data.success) {
            if (response.data.data && response.data.data.length > 0) {
              _this.exchangeRateData = response.data.data;
              _this.total = response.data.total;
            } else {
              _this.exchangeRateData = [];
            }
          } else {
            _this.$message.error(response.data.message);
          }
        })
        .catch(error => {});
    },
    // 添加/编辑汇率
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'POST',
            url: '/exchange/save',
            data: this.exchangeRateForm
          })
            .then(response => {
              if (response.data.success) {
                this.$message.success("成功！");
                this.initQuery();                
                this.$refs[formName].resetFields();
                this.emptyForm();
                this.dialogFormVisible = false;
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(error => {});
        } else {
          return false;
        }
      });
    },
    popEditLog(id) {
      let _this = this;
      _this.exchangeRateEditLogsVisible = true;
      _this.$request1({
        method: 'GET',
        url: '/exchange/query-log',
        params: {
          id: id
        }
      })
        .then(function(res) {
          if (res.data.success) {
            _this.exchangeRateEditLogs = res.data.data;
          }
        })
        .catch(function(error) {});
    },
    createExchangeRate() {
      this.dialogFormVisible = true
      this.exchangeRateForm.id = ""
      this.exchangeRateForm.currency =  ""
      this.exchangeRateForm.exchangeRate =  ""
      this.getCurrencies();
    },
    //编辑
    handleEdit(index, row) {
      this.getCurrencies();
			this.exchangeRateForm.id = row.id;
      this.exchangeRateForm.currency = row.currency; 
      this.exchangeRateForm.exchangeRate = row.exchangeRate;
      this.dialogFormVisible = true;
    },
    //清空表单
    emptyForm() {
      this.exchangeRateForm.id = "";
      this.exchangeRateForm.currency = "";
      this.exchangeRateForm.exchangeRate = "";
      this.dialogFormVisible = false;
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    resetForm(formName) {
      this.$refs[formName].clearValidate();
      this.emptyForm();
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    getCurrencies() {
      let _this = this;
      _this.$request1({
        method: 'GET',
        url: '/exchange/currencies',
        params: {
          type: "EXCHANGE_RATE"
        }
      })
        .then(response => {
          if (response.data.success) {
            if (response.data.data && response.data.data.length > 0) {
               let exchangeRateData = response.data.data;
               _this.currencies = [];
               exchangeRateData.forEach((item, index) => {
                 if(item.value != "CNY") {
                   let currencies = { name: "", value: ""};
                   currencies.name = item.name;
                   currencies.value = item.value;
                   _this.currencies.push(currencies);
                 }
               })
            }
          } else {
            _this.$message.error(response.data.message);
          }
        })
        .catch(error => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/exchange_rate.vue